// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoriesFilter_root__UgUDv"};